import Sortable from 'sortablejs';

const sortableItems = document.querySelectorAll('[data-sortable]');

sortableItems.forEach((sortableItem) => {
  Sortable.create(sortableItem, {
    handle: '.handle'
  })
});